import React from 'react'
import Portfolio from './components/pages/Portfolio';
import Projects from './components/pages/Projects';
import Contact from './components/pages/Contact';
import About from './components/pages/About';
import Home from './components/pages/Home';
import {Route, Switch } from 'react-router-dom'

const Routes = () => {
    return (
        <>
            <Switch>
              <Route path='/' exact component={Home} />
              <Route path='/portfolio' component={Portfolio} />
              <Route path='/projects' component={Projects} />
              <Route path='/about' component={About} />
              <Route path='/contact' component={Contact} />
            </Switch>
              
        </>
    )
}

export default Routes
